import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import LogoCarousel from '@segment/templates/LogoCarousel'

import Layout from '@segment/next-shared/layout'

import DeliverExperiences from './components/DeliverExperiences'
import GettingStarted from './components/GettingStarted'
import Hero from './components/Hero'
import LearnMore from './components/LearnMore'
import TestimonialsSlider from './components/TestimonialsSlider'
import UseAi from './components/UseAi'

const copy = {
  pageTitle: `Boost cross-sell and upsell | Twilio Segment`,
  pageDescription: `Explore how Twilio Segment’s customer data platform can help you efficiently grow revenue through cross-sell and upsell.`,
}

const BoostCrossSellUpsellView: FC = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        bodyBackground={theme.palette.neutrals.white[100]}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <AppearanceProvider appearance="twilioDark">
          <Hero />
        </AppearanceProvider>
        <Main>
          <LogoCarouselWrapper>
            <LogoCarousel />
          </LogoCarouselWrapper>
          <DeliverExperiences />
          <UseAi />
          <LearnMore />
          <TestimonialsSlider />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main``

const LogoCarouselWrapper = styled.div`
  padding: 80px 0;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding: 40px 0;
  }
`

export default BoostCrossSellUpsellView
